const enumValue = description => Object.freeze({toString: () => description});

export const PROCESSING = enumValue('PROCESSING');
export const PROCESSED = enumValue('PROCESSED');
export const CREATED = enumValue('');
export const ERROR = enumValue('ERROR');